import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { OperationsDataGrid } from "src/components/views/erp/production/masterData/operations/OperationsDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/production/operations")({
	staticData: { title: i18n.t("operations"), legacyViewKey: "operationsPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <OperationsDataGrid />;
}
